import React from 'react';
import {View} from 'react-native';

import sy from '~/styles';
import {Dialog, FormNumberInput} from '~/components/controls';

const DiscountDialog = ({value, amount, onDismiss}) => (
  <Dialog
    visible={true}
    title="Korting"
    onDismiss={onDismiss}
    buttons={[
      {
        text: 'Sluiten',
        onPress: onDismiss,
      },
    ]}
    options={{noPaddingContent: true}}>
    <View style={[sy['p-4'], sy['gap-4']]}>
      <FormNumberInput label="Kortingsbedrag" digits={2} value={value} />
      <FormNumberInput
        label="Bedrag na korting"
        digits={2}
        value={amount - value}
      />
    </View>
  </Dialog>
);

export default DiscountDialog;
